import React from "react";

const sections = [
  {
    number: "1",
    title: "Información que recopilamos",
    subsections: [
      {
        subtitle: "1.1 Información proporcionada por el usuario",
        items: [
          "Nombre",
          "Dirección de correo electrónico",
          "Número de teléfono (si es proporcionado por el usuario)",
          "Dirección (si es requerida para la prestación del servicio)",
          "CUIT (si el usuario lo proporciona para fines administrativos o de facturación)",
        ],
      },
      {
        subtitle: "1.2 Contenido del usuario",
        items: [
          "Imágenes y archivos cargados por el usuario dentro de la aplicación (por ejemplo, imágenes de propiedades u otros contenidos enviados para su procesamiento o edición)",
        ],
      },
      {
        subtitle: "1.3 Información de uso",
        items: [
          "Interacciones dentro de la aplicación (solicitudes realizadas, acciones del usuario, eventos de uso)",
          "Registros técnicos y de error",
        ],
      },
      {
        subtitle: "1.4 Información técnica",
        items: [
          "Tipo de dispositivo",
          "Sistema operativo",
          "Versión de la aplicación",
          "Identificadores técnicos del dispositivo (cuando sea necesario para el funcionamiento del servicio)",
        ],
      },
    ],
  },
  {
    number: "2",
    title: "Uso de la información",
    items: [
      "Proveer y operar el servicio de la aplicación",
      "Procesar solicitudes del usuario (incluyendo edición o procesamiento de contenido)",
      "Entregar los resultados solicitados (por ejemplo, imágenes editadas mediante Google Drive u otros medios)",
      "Mejorar la estabilidad, seguridad y calidad del servicio",
      "Brindar soporte al usuario",
      "Cumplir obligaciones legales o regulatorias",
    ],
    intro: "La información recopilada se utiliza exclusivamente para:",
  },
  {
    number: "3",
    title: "Base legal para el tratamiento de datos",
    items: [
      "El consentimiento del usuario",
      "La necesidad de ejecución del servicio solicitado",
      "El cumplimiento de obligaciones legales cuando corresponda",
    ],
    intro: "Tratamos los datos personales del usuario con base en:",
  },
  {
    number: "4",
    title: "Almacenamiento y proveedores de terceros",
    items: [
      "Supabase (almacenamiento y base de datos)",
      "Google Cloud (infraestructura y procesamiento)",
      "Google Drive (entrega de archivos)",
    ],
    intro:
      "Podemos almacenar y procesar información utilizando servicios de terceros, incluyendo:",
    outro:
      "Estos proveedores pueden procesar datos en diferentes jurisdicciones y operan bajo sus propias políticas de privacidad y estándares de seguridad.",
  },
  {
    number: "5",
    title: "Transferencia internacional de datos",
    text: "La información puede ser almacenada y procesada en servidores ubicados fuera del país del usuario, incluyendo Estados Unidos u otras jurisdicciones donde operen nuestros proveedores tecnológicos.",
  },
  {
    number: "6",
    title: "Compartición de información",
    items: [
      "Con proveedores de servicios necesarios para el funcionamiento de la aplicación",
      "Para cumplir obligaciones legales o requerimientos de autoridades competentes",
      "Para proteger derechos, seguridad o integridad de los usuarios y del servicio",
    ],
    intro: "Podemos compartir información únicamente en los siguientes casos:",
    preIntro: "No vendemos ni alquilamos datos personales.",
  },
  {
    number: "7",
    title: "Seguridad de la información",
    text: "Implementamos medidas técnicas y organizativas razonables para proteger la información contra accesos no autorizados, pérdida, uso indebido o divulgación.",
  },
  {
    number: "8",
    title: "Retención de datos",
    items: [
      "Prestar el servicio solicitado",
      "Cumplir obligaciones legales",
      "Resolver disputas o hacer cumplir acuerdos",
    ],
    intro: "Conservamos los datos únicamente durante el tiempo necesario para:",
    outro: "El usuario puede solicitar la eliminación de sus datos en cualquier momento.",
  },
  {
    number: "9",
    title: "Derechos del usuario",
    items: [
      "Acceso a sus datos personales",
      "Corrección de datos incorrectos",
      "Eliminación de sus datos",
      "Limitación del tratamiento",
      "Retiro del consentimiento (cuando aplique)",
    ],
    intro: "El usuario puede solicitar:",
    outro: "Para ejercer estos derechos, puede contactarnos en el correo indicado abajo.",
  },
  {
    number: "10",
    title: "Menores de edad",
    text: "La aplicación no está dirigida a menores de 18 años. No recopilamos intencionalmente datos de menores.",
  },
  {
    number: "11",
    title: "Cambios a esta política",
    text: "Podemos actualizar esta Política de Privacidad en cualquier momento. Notificaremos cambios relevantes dentro de la aplicación o mediante otros canales apropiados.",
  },
];

export default function PoliticaPrivacidad() {
  return (
    <div style={styles.page}>
      <div style={styles.container}>
        {/* Header */}
        <div style={styles.header}>
          <div style={styles.badge}>Privacidad</div>
          <h1 style={styles.title}>Política de Privacidad</h1>
          <p style={styles.subtitle}>RealtyShot</p>
          <p style={styles.date}>Última actualización: 20/05/2026</p>
        </div>

        {/* Intro */}
        <div style={styles.intro}>
          <p style={styles.introText}>
            Esta Política de Privacidad describe cómo la aplicación{" "}
            <strong>RealtyShot</strong> recopila, utiliza, almacena y protege la
            información de los usuarios.
          </p>
        </div>

        {/* Sections */}
        {sections.map((section) => (
          <div key={section.number} style={styles.section}>
            <div style={styles.sectionHeader}>
              <span style={styles.sectionNumber}>{section.number}</span>
              <h2 style={styles.sectionTitle}>{section.title}</h2>
            </div>

            <div style={styles.sectionContent}>
              {section.preIntro && (
                <p style={styles.text}>{section.preIntro}</p>
              )}
              {section.text && <p style={styles.text}>{section.text}</p>}
              {section.intro && <p style={styles.text}>{section.intro}</p>}

              {section.items && (
                <ul style={styles.list}>
                  {section.items.map((item, i) => (
                    <li key={i} style={styles.listItem}>
                      <span style={styles.bullet}>—</span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              )}

              {section.outro && <p style={styles.text}>{section.outro}</p>}

              {section.subsections &&
                section.subsections.map((sub, i) => (
                  <div key={i} style={styles.subsection}>
                    <h3 style={styles.subsectionTitle}>{sub.subtitle}</h3>
                    <ul style={styles.list}>
                      {sub.items.map((item, j) => (
                        <li key={j} style={styles.listItem}>
                          <span style={styles.bullet}>—</span>
                          <span>{item}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
            </div>
          </div>
        ))}

        {/* Contact */}
        <div style={styles.contactCard}>
          <h2 style={styles.contactTitle}>12. Contacto</h2>
          <p style={styles.contactText}>
            Para consultas sobre privacidad o el tratamiento de datos:
          </p>
          <a href="mailto:info@realty-shot.com" style={styles.contactEmail}>
            info@realty-shot.com
          </a>
          <p style={styles.contactCompany}>RealtyShot</p>
        </div>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    backgroundColor: "#f8f7f4",
    fontFamily: "'Georgia', 'Times New Roman', serif",
    padding: "48px 16px",
  },
  container: {
    maxWidth: "760px",
    margin: "0 auto",
  },
  header: {
    marginBottom: "48px",
    paddingBottom: "40px",
    borderBottom: "1px solid #e0ddd6",
  },
  badge: {
    display: "inline-block",
    backgroundColor: "#1a1a1a",
    color: "#f8f7f4",
    fontSize: "11px",
    fontFamily: "'Courier New', monospace",
    letterSpacing: "2px",
    textTransform: "uppercase",
    padding: "6px 14px",
    marginBottom: "24px",
  },
  title: {
    fontSize: "42px",
    fontWeight: "400",
    color: "#1a1a1a",
    margin: "0 0 8px 0",
    lineHeight: "1.1",
    letterSpacing: "-0.5px",
  },
  subtitle: {
    fontSize: "18px",
    color: "#8a7f6e",
    margin: "0 0 16px 0",
    fontStyle: "italic",
  },
  date: {
    fontSize: "13px",
    color: "#a09585",
    fontFamily: "'Courier New', monospace",
    margin: "0",
  },
  intro: {
    backgroundColor: "#fff",
    border: "1px solid #e0ddd6",
    borderLeft: "3px solid #1a1a1a",
    padding: "24px 28px",
    marginBottom: "40px",
  },
  introText: {
    fontSize: "16px",
    color: "#3a3530",
    lineHeight: "1.7",
    margin: "0",
  },
  section: {
    marginBottom: "36px",
    backgroundColor: "#fff",
    border: "1px solid #e0ddd6",
    overflow: "hidden",
  },
  sectionHeader: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
    padding: "20px 28px",
    borderBottom: "1px solid #e0ddd6",
    backgroundColor: "#faf9f6",
  },
  sectionNumber: {
    fontFamily: "'Courier New', monospace",
    fontSize: "12px",
    color: "#a09585",
    minWidth: "20px",
  },
  sectionTitle: {
    fontSize: "17px",
    fontWeight: "600",
    color: "#1a1a1a",
    margin: "0",
    fontFamily: "'Georgia', serif",
  },
  sectionContent: {
    padding: "24px 28px",
  },
  text: {
    fontSize: "15px",
    color: "#3a3530",
    lineHeight: "1.7",
    margin: "0 0 16px 0",
  },
  list: {
    margin: "8px 0 16px 0",
    padding: "0",
    listStyle: "none",
  },
  listItem: {
    display: "flex",
    gap: "12px",
    fontSize: "15px",
    color: "#3a3530",
    lineHeight: "1.6",
    padding: "6px 0",
    borderBottom: "1px solid #f0ede6",
  },
  bullet: {
    color: "#a09585",
    fontFamily: "'Courier New', monospace",
    flexShrink: 0,
    marginTop: "1px",
  },
  subsection: {
    marginTop: "20px",
  },
  subsectionTitle: {
    fontSize: "14px",
    fontWeight: "600",
    color: "#5a5048",
    fontFamily: "'Courier New', monospace",
    letterSpacing: "0.5px",
    margin: "0 0 12px 0",
    textTransform: "uppercase",
  },
  contactCard: {
    backgroundColor: "#1a1a1a",
    color: "#f8f7f4",
    padding: "40px",
    marginTop: "8px",
  },
  contactTitle: {
    fontSize: "20px",
    fontWeight: "400",
    color: "#f8f7f4",
    margin: "0 0 16px 0",
    fontFamily: "'Georgia', serif",
  },
  contactText: {
    fontSize: "15px",
    color: "#a09585",
    margin: "0 0 16px 0",
    lineHeight: "1.6",
  },
  contactEmail: {
    display: "block",
    fontSize: "18px",
    color: "#f8f7f4",
    textDecoration: "none",
    borderBottom: "1px solid #a09585",
    paddingBottom: "16px",
    marginBottom: "16px",
    fontFamily: "'Courier New', monospace",
  },
  contactCompany: {
    fontSize: "13px",
    color: "#a09585",
    fontFamily: "'Courier New', monospace",
    letterSpacing: "2px",
    textTransform: "uppercase",
    margin: "0",
  },
};